import { render, staticRenderFns } from "./ColorPickerV2.vue?vue&type=template&id=33c1f1f0&scoped=true&"
import script from "./ColorPickerV2.vue?vue&type=script&lang=js&"
export * from "./ColorPickerV2.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerV2.vue?vue&type=style&index=0&id=33c1f1f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c1f1f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VColorPicker,VIcon,VMenu,VRow})
